<template>
  <CTabs variant="tabs" class="nav-tabs-boxed" v-if="dataLoaded">
    <CTab title="Fabricantes">
      <TintometricoFabricante
          :key="uniqueKey"
          @fabricantes-changed="onFabricantesChanged"
      />
    </CTab>
    <CTab title="Integrações">
      <TintometricoIntegracao
          :fabricantes="fabricantes"
          :fabricantesDetalhes="fabricantesDetalhes"
          :filiais="filiais"
          :key="uniqueKey"
      />
    </CTab>
    <CTab title="Linhas">
      <TintometricoLinha
          :fabricantes="fabricantes"
          :key="uniqueKey"
      />
    </CTab>
    <CTab title="Bases">
      <TintometricoBase
          :fabricantes="fabricantes"
          :key="uniqueKey"
      />
    </CTab>
    <CTab title="Cores">
      <TintometricoCor
          :fabricantes="fabricantes"
          :key="uniqueKey"
      />
    </CTab>
    <CTab title="Corantes">
      <TintometricoCorante
          :fabricantes="fabricantes"
          :key="uniqueKey"
      />
    </CTab>
    <CTab title="Embalagens">
      <TintometricoEmbalagem
          :fabricantes="fabricantes"
          :key="uniqueKey"
      />
    </CTab>
  </CTabs>
</template>

<script>

import TintometricoFabricante from "@/views/Tintometrico/TintometricoFabricante.vue";
import TintometricoIntegracao from "@/views/Tintometrico/TintometricoIntegracao.vue";
import TintometricoLinha from "@/views/Tintometrico/TintometricoLinha.vue";
import TintometricoBase from "@/views/Tintometrico/TintometricoBase.vue";
import TintometricoCor from "@/views/Tintometrico/TintometricoCor.vue";
import TintometricoCorante from "@/views/Tintometrico/TintometricoCorante.vue";
import TintometricoEmbalagem from "@/views/Tintometrico/TintometricoEmbalagem.vue";
import { get} from '@/helpers/apiRequest';

export default {
  name: 'Tintometrico',
  components: {
    TintometricoFabricante,
    TintometricoIntegracao,
    TintometricoLinha,
    TintometricoBase,
    TintometricoCor,
    TintometricoCorante,
    TintometricoEmbalagem
  },
  data(){
    return {
        filiais: {},
        fabricantes: {},
        fabricantesDetalhes: [],
        uniqueKey: 0,
        dataLoaded: false
    };
  },
  async mounted() {
    await this.loadData().then(() => {
      setTimeout(() => {
        this.dataLoaded = true
      }, 1000)
    })
  },
  methods: {
    loadFiliais(){
      get('/admin/tintometrico/filiais-ativas')
          .then((json) => {
            json.map((filial) => {
              this.$set(this.filiais, filial.id, filial.desc);
            });
          })
    },
    loadFabricantes(){
      return get('/admin/tintometrico/fabricantes')
          .then((json) => {
            this.fabricantesDetalhes = json;
            const novoMap = {};
            json.forEach((fabricante) => {
              novoMap[fabricante.id] = fabricante.chave;
            });
            this.fabricantes = novoMap;
          })
    },
    async loadData() {
      await this.loadFabricantes();
      await this.loadFiliais();
    },
    onFabricantesChanged() {
      return this.loadFabricantes();
    }
  },
}

</script>

<style src="./tintometrico.css"></style>
